 



<section class="team-section text-center my-5 ">

        <!-- Section heading -->
        <h2 class="h1-responsive color-primary my-5">Team</h2>
        <!-- Section description
        <p class="px-5 mb-5 pb-3 lead text-dark">Lorem ipsum dolor sit amet, consectetur adipisicing elit.
          Fugit, error
          amet numquam iure provident voluptate esse quasi,
          veritatis totam voluptas nostrum quisquam eum porro a pariatur veniam.</p>
       -->
        <!-- Grid row -->
        <div class="row">
      
          <!-- Grid column -->
          <div class="col-lg-4 col-md-6 mb-lg-0 mb-5" *ngFor="let member of team">
            <div class="avatar mx-auto">
              <img src="../../assets/img/{{member.img}}" class="rounded-circle z-depth-1"
                alt="Sample avatar">
            </div>
            <h5 class="  mt-4 mb-3 color-primary">{{member.first}} {{member.last}}</h5>
         
            <ul class="text-dark text-left">    
              <li>{{member.title}} </li>
                   <li *ngFor="let cap of member.caps">{{cap}}</li>
            </ul>
            <ul class="list-unstyled mb-0">
   
          
              <a class="p-2 fa-lg ins-ic" href="mailto:{{member.email}}">
                    <i class="fas fa-envelope color-primary"></i>
              </a>
            </ul>
          </div>
          <!-- Grid column -->
      
 
      
        </div>
        <!-- Grid row -->
      
      </section>
      <!-- Section: Team v.1 -->

 